


























import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import CNumberField from '@/components/base/numberField/CNumberField.vue';
import CSelect from '@/components/base/select/CSelect.vue';
@Component({
    components: {CSelect, CNumberField},
})
export default class CVolumeField extends Vue {
    @Prop() value!: {
        Value: number | null;
        IdMeasureUnit: number | null;
    };
    @Prop({
        default: Number.MAX_SAFE_INTEGER,
    })
    max!: number;
    @Prop({
        default: 0,
    })
    min!: number;
    @Prop() label!: string;
    @Prop({default: false, type: Boolean}) nullable!: boolean;

    private localValue = this.value;

    @Watch('localValue', {deep: true})
    onLocalValueChange(value: any) {
        if (this.nullable && value.Value === null) this.$emit('input', Object.assign({}, value, {IdMeasureUnit: null}));
        else this.$emit('input', value);
    }

    async mounted() {
        if (this.nullable && this.localValue.IdMeasureUnit === null) {
            const descriptions = await (this.$refs.select as any).getItems();
            this.localValue.IdMeasureUnit = descriptions[0].Id;
        }
    }
}
